var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54346 18.2834V15.0791H6.74782",
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1422 8.4209C18.9395 12.6608 16.3449 16.8642 12.1087 17.9994C8.86646 18.8681 5.55828 17.6995 3.54346 15.2783",
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76268 11.4835C0.965378 7.2436 3.56004 3.04018 7.79625 1.90509C11.0383 1.03639 14.3462 2.20479 16.3611 4.62567",
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3606 1.62109V4.82546H13.1562",
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1921 10.3839C5.7387 10.3051 5.7387 9.65418 6.1921 9.5753C7.8347 9.28953 9.14116 8.0384 9.49769 6.4097L9.52502 6.28485C9.62312 5.83675 10.2612 5.83396 10.3632 6.28118L10.3964 6.42668C10.7661 8.0477 12.0729 9.28826 13.7109 9.57323C14.1666 9.65252 14.1666 10.3067 13.7109 10.386C12.0729 10.671 10.7661 11.9115 10.3964 13.5325L10.3632 13.678C10.2612 14.1253 9.62312 14.1225 9.52502 13.6744L9.49769 13.5495C9.14116 11.9208 7.8347 10.6697 6.1921 10.3839Z",
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.f4180bb8.svg";
export { ForwardRef as ReactComponent };